
import * as z from "zod";

export const studentSchema = z.object({
  first_name: z.string().min(2, "Nome deve ter pelo menos 2 caracteres"),
  last_name: z.string().min(2, "Sobrenome deve ter pelo menos 2 caracteres"),
  email: z.string().email("Email inválido").optional().or(z.literal("")),
  phone: z.string().optional(),
  birth_date: z.string().optional(),
  height: z.string().optional(),
  weight: z.string().optional(),
  medical_conditions: z.string().optional(),
  emergency_contact: z.string().optional(),
  preferred_training_time: z.enum(['manha', 'tarde', 'noite']).optional(),
  fitness_level: z.enum(['iniciante', 'intermediario', 'avancado']).optional(),
  initial_assessment_date: z.string().optional(),
  initial_assessment_notes: z.string().optional(),
  preferred_training_type: z.enum(['musculacao', 'funcional', 'cardio', 'hiit', 'pilates']).optional(),
  goals: z.string().optional(),
  notes: z.string().optional(),
  monthly_fee: z.string().optional(),
  payment_status: z.enum(['pago', 'pendente', 'atrasado']).optional(),
  payment_method: z.enum(['transferencia', 'dinheiro', 'cartao', 'debito_direto']).optional(),
  payment_notes: z.string().optional(),
  has_schedule_access: z.boolean().optional().default(true),
  send_account_email: z.boolean().optional().default(true),
});

export type StudentFormValues = z.infer<typeof studentSchema>;
